import PropTypes from 'prop-types'
import React from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'
import { thumbnailState } from '../recoil/state/results'
import {
  onThumbErrorCallback,
  updateThumbCallback
} from '../recoil/callbacks/callbacks'

const StyledImage = styled.img`
  ${({ $loading }) => ($loading ? 'display:none;' : '')}
`

const ThumbImage = ({ id }) => {
  const { loading, thumbnail } = useRecoilValue(thumbnailState(id))

  const updateThumb = useRecoilCallback(updateThumbCallback, [])

  const onThumbError = useRecoilCallback(onThumbErrorCallback, [])

  const onError = e => {
    onThumbError(id)
  }

  const onLoad = e => {
    updateThumb(id, { error: false, loading: false })
  }

  return (
    <StyledImage
      $loading={loading}
      src={thumbnail}
      alt=''
      onLoad={onLoad}
      onError={onError}
    />
  )
}

ThumbImage.propTypes = {
  id: PropTypes.number.isRequired
}

export default ThumbImage
